import { EncryptStorage } from 'encrypt-storage';

/**
 * Instance of the EncryptStorage class used for encrypting and storing data in local storage.
 *
 * @remarks
 * The `encryptStorage` object is initialized with a secret key and storage type.
 *
 * @example
 * const encryptStorage = new EncryptStorage(
 *   (process.env.REACT_APP_SECRET_KEY || 'YOUR_SECRET_KEY')?.toString(),
 *   {
 *     storageType: 'localStorage',
 *   },
 * );
 */
const encryptStorage = new EncryptStorage(
	(process.env.REACT_APP_SECRET_KEY || 'YOUR_SECRET_KEY')?.toString(),
	{
		storageType: 'localStorage',
	},
);

/**
 * Wrapper object for interacting with the local storage.
 */
const localStorageWrapper = {
	/**
	 * Retrieves the value of the specified item from the local storage.
	 * @param item - The name of the item to retrieve.
	 * @returns The value of the item, or null if the item does not exist.
	 */
	getStorageItem: (item: string) => encryptStorage.getItem(item),

	/**
	 * Sets the value of the specified item in the local storage.
	 * @param key - The name of the item to set.
	 * @param value - The value to set for the item.
	 */
	setStorageItem: (key: string, value: any) =>
		encryptStorage.setItem(key, value),

	removeStorageItem: (key: string) => encryptStorage.removeItem(key),
	/**
	 * Clears all items from the local storage.
	 */
	clearStorage: () => encryptStorage.clear(),
};

export default localStorageWrapper;
